Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.viewTipRating = exports.clickSendRating = exports.clickOpenLinkModal = exports.clickOpenFirstTipModal = exports.clickCloseSecurityModal = exports.clickCloseFirstTipModal = void 0;
var lurkerSend = function lurkerSend(event_type, object_name, object_detail) {
  var data = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var payload = Object.assign({
    event_type: event_type,
    object_name: object_name,
    object_detail: object_detail
  }, data);
  if (!window.Lurker) {
    window.beforeLurkerLoadEvents = window.beforeLurkerLoadEvents || [];
    window.beforeLurkerLoadEvents.push(payload);
    return;
  }
  window.Lurker.send(payload)["catch"](console.error);
};
var clickCloseSecurityModal = function clickCloseSecurityModal(extra) {
  return lurkerSend('click', 'chat', 'close-modal-contentmod-security', Object.assign({}, extra));
};
exports.clickCloseSecurityModal = clickCloseSecurityModal;
var clickCloseFirstTipModal = function clickCloseFirstTipModal(extra) {
  return lurkerSend('click', 'chat', 'close-modal-contentmod-first-tip', Object.assign({}, extra));
};
exports.clickCloseFirstTipModal = clickCloseFirstTipModal;
var clickOpenFirstTipModal = function clickOpenFirstTipModal(extra) {
  return lurkerSend('click', 'chat', 'open-modal-contentmod-first-tip', Object.assign({}, extra));
};
exports.clickOpenFirstTipModal = clickOpenFirstTipModal;
var clickOpenLinkModal = function clickOpenLinkModal(extra) {
  return lurkerSend('click', 'chat', 'open_link_modal_first_chat', Object.assign({}, extra));
};
exports.clickOpenLinkModal = clickOpenLinkModal;
var clickSendRating = function clickSendRating(extra) {
  return lurkerSend('click', 'chat', 'chat_rating', Object.assign({}, extra));
};
exports.clickSendRating = clickSendRating;
var viewTipRating = function viewTipRating(extra) {
  return lurkerSend('view', 'chat', 'chat_rating', Object.assign({}, extra));
};
exports.viewTipRating = viewTipRating;